import React from 'react';
import { DMRVPageTemplate } from '../components/dmrv/DMRVPageTemplate';
export function ForestryREDD() {
  return <DMRVPageTemplate id="forestry" tagline="Forestry & REDD+ | Uganda" headline="Satellite-Verified Forest Carbon Monitoring" highlightWord="Forest Carbon" description="Uganda loses 90,000+ hectares of forest annually. CarbonSafe combines satellite imagery, ground-truthing, and AI-powered analytics to deliver transparent DMRV for REDD+ and afforestation carbon credit projects." badges={['REDD+ Compliant', 'Verra VCS', 'UNFCCC CDM']} heroEmoji="🌳" heroImage="https://f000.backblazeb2.com/file/jpgshared/-aRbs6Fg" floatingIcons={[{
    emoji: '🛰️',
    position: 'top'
  }, {
    emoji: '📍',
    position: 'right'
  }, {
    emoji: '🌿',
    position: 'left'
  }]} statsHeadline="Uganda's forest crisis demands action" statsSubtext="Rapid deforestation threatens biodiversity, livelihoods, and climate goals across East Africa." stats={[{
    value: '90K+',
    label: 'Hectares Lost/Year',
    detail: "Uganda's annual deforestation rate, one of the highest in Africa"
  }, {
    value: '3.6M',
    label: 'Hectares Remaining',
    detail: 'Down from 4.9M hectares in 2000, a 27% decline in two decades'
  }, {
    value: '40M+',
    label: 'Tons CO₂/year',
    detail: 'Emissions from deforestation and forest degradation in Uganda'
  }, {
    value: '$500M+',
    label: 'REDD+ Potential',
    detail: "Estimated annual carbon credit revenue from Uganda's forest conservation"
  }]} howItWorksVerticalName="forestry & REDD+" howItWorksSubtext="From satellite to credit registry, four steps to verified forest carbon." howItWorksSteps={[{
    icon: 'GlobeIcon',
    title: 'Satellite Monitoring',
    description: 'Multi-spectral imagery detects forest cover changes across project boundaries.'
  }, {
    icon: 'MapPinIcon',
    title: 'Ground-Truthing',
    description: 'Field teams verify satellite data with GPS-tagged photos and biomass measurements.'
  }, {
    icon: 'BarChart3Icon',
    title: 'Carbon Stock Calculation',
    description: 'AI-powered models quantify above and below-ground carbon using field and remote data.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'REDD+ Credit Verification',
    description: 'Independently verified credits with permanence monitoring and buffer pool management.'
  }]} impactImageUrl="https://media.springernature.com/full/springer-static/image/art%3A10.1038%2Fs43017-024-00601-6/MediaObjects/43017_2024_601_Fig1_HTML.png" impactImageAlt="Satellite-based forest carbon monitoring methodology" impactTagline="Satellite + Ground Truth" impactHeadline="Seeing the forest and the trees" impactDescription="CarbonSafe fuses satellite imagery with on-the-ground field data to deliver forest carbon monitoring that's both scalable and precise, covering millions of hectares without sacrificing accuracy." impactCtaText="Explore Forest Monitoring" featuresHeadline="The challenge of" featuresHighlight="forest carbon verification" featuresSubtext="REDD+ projects require rigorous, continuous monitoring that traditional methods cannot deliver at scale." features={[{
    icon: 'GlobeIcon',
    title: 'Satellite Monitoring',
    description: 'Multi-spectral satellite imagery detects deforestation events within 48 hours across Albertine Rift, Murchison Falls, and Budongo Forest reserves.'
  }, {
    icon: 'MapPinIcon',
    title: 'Ground-Truthing',
    description: 'Mobile-based field verification with GPS-tagged photo evidence, species identification, and biomass measurement at sample plots.'
  }, {
    icon: 'BarChart3Icon',
    title: 'Carbon Stock Modeling',
    description: 'AI-powered allometric models calculate above-ground and below-ground carbon stocks using LiDAR and field data fusion.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Additionality Proof',
    description: 'Digital baseline documentation and counterfactual modeling prove that conservation efforts create real, additional emission reductions.'
  }, {
    icon: 'LeafIcon',
    title: 'Biodiversity Co-benefits',
    description: 'Track species diversity, habitat connectivity, and ecosystem health alongside carbon metrics for premium credit pricing.'
  }, {
    icon: 'ScaleIcon',
    title: 'Permanence Monitoring',
    description: 'Continuous 25-year monitoring with buffer pool management and early warning systems for reversal risks.'
  }]} ctaHeadline="Every tree counts." ctaHighlight="Prove it with data." ctaSubtext="Join conservation organizations using CarbonSafe to generate verified REDD+ credits from Uganda's forests." ctaButtonText="Start Your REDD+ Project" platformPreview={{
    headline: 'Forest carbon monitoring in',
    highlightWord: 'one dashboard',
    subtext: 'Track deforestation alerts, carbon stocks, and REDD+ credit generation across all project sites.',
    urlPath: 'forestry',
    projectName: 'Budongo Forest Reserve | REDD+',
    statusLabel: 'Monitoring',
    sidebarItems: [{
      icon: 'Dashboard',
      label: 'Dashboard',
      active: true
    }, {
      icon: 'Projects',
      label: 'Projects'
    }, {
      icon: 'Satellite',
      label: 'Satellite'
    }, {
      icon: 'Field Data',
      label: 'Field Data'
    }, {
      icon: 'Reports',
      label: 'Reports'
    }, {
      icon: 'Settings',
      label: 'Settings'
    }],
    stats: [{
      label: 'Forest Area',
      value: '82,400 ha'
    }, {
      label: 'Canopy Cover',
      value: '94.2%',
      highlight: true
    }, {
      label: 'tCO₂e Stored',
      value: '1.2M'
    }, {
      label: 'Credits Issued',
      value: '$4.8M'
    }],
    chartLabel: 'Monthly Deforestation Alerts',
    activityItems: [{
      icon: 'GlobeIcon',
      iconColor: 'text-carbon-bright',
      label: 'Satellite scan complete',
      detail: 'Budongo sector A-C',
      time: '12m ago'
    }, {
      icon: 'MapPinIcon',
      iconColor: 'text-emerald-500',
      label: 'Field verification submitted',
      detail: 'Plot #847 biomass data',
      time: '2h ago'
    }, {
      icon: 'ShieldCheckIcon',
      iconColor: 'text-blue-500',
      label: 'Credits batch #12 issued',
      detail: '2,400 tCO₂e verified',
      time: '1d ago'
    }]
  }} data-id="element-1475" />;
}